// Breed name localization utility
export interface BreedNames {
  en: string;
  'zh-CN': string;
  es: string;
  fr: string;
}

export const BREED_NAMES: Record<string, BreedNames> = {
  // Dog breeds
  'Golden Retriever': {
    en: 'Golden Retriever',
    'zh-CN': '金毛寻回犬',
    es: 'Golden Retriever',
    fr: 'Golden Retriever'
  },
  'Labrador Retriever': {
    en: 'Labrador Retriever',
    'zh-CN': '拉布拉多寻回犬',
    es: 'Labrador Retriever',
    fr: 'Labrador Retriever'
  },
  'German Shepherd': {
    en: 'German Shepherd',
    'zh-CN': '德国牧羊犬',
    es: 'Pastor Alemán',
    fr: 'Berger Allemand'
  },
  'French Bulldog': {
    en: 'French Bulldog',
    'zh-CN': '法国斗牛犬',
    es: 'Bulldog Francés',
    fr: 'Bouledogue Français'
  },
  'Bulldog': {
    en: 'Bulldog',
    'zh-CN': '斗牛犬',
    es: 'Bulldog',
    fr: 'Bouledogue'
  },
  'Poodle': {
    en: 'Poodle',
    'zh-CN': '贵宾犬',
    es: 'Caniche',
    fr: 'Caniche'
  },
  'Beagle': {
    en: 'Beagle',
    'zh-CN': '比格犬',
    es: 'Beagle',
    fr: 'Beagle'
  },
  'Rottweiler': {
    en: 'Rottweiler',
    'zh-CN': '罗威纳犬',
    es: 'Rottweiler',
    fr: 'Rottweiler'
  },
  'German Shorthaired Pointer': {
    en: 'German Shorthaired Pointer',
    'zh-CN': '德国短毛指示犬',
    es: 'Pointer Alemán de Pelo Corto',
    fr: 'Braque Allemand à Poil Court'
  },
  'Yorkshire Terrier': {
    en: 'Yorkshire Terrier',
    'zh-CN': '约克夏梗',
    es: 'Yorkshire Terrier',
    fr: 'Yorkshire Terrier'
  },
  'Siberian Husky': {
    en: 'Siberian Husky',
    'zh-CN': '西伯利亚哈士奇',
    es: 'Husky Siberiano',
    fr: 'Husky Sibérien'
  },
  'Dachshund': {
    en: 'Dachshund',
    'zh-CN': '腊肠犬',
    es: 'Dachshund',
    fr: 'Teckel'
  },
  'Boxer': {
    en: 'Boxer',
    'zh-CN': '拳师犬',
    es: 'Boxer',
    fr: 'Boxer'
  },
  'Great Dane': {
    en: 'Great Dane',
    'zh-CN': '大丹犬',
    es: 'Gran Danés',
    fr: 'Dogue Allemand'
  },
  'Chihuahua': {
    en: 'Chihuahua',
    'zh-CN': '吉娃娃',
    es: 'Chihuahua',
    fr: 'Chihuahua'
  },
  'Shih Tzu': {
    en: 'Shih Tzu',
    'zh-CN': '西施犬',
    es: 'Shih Tzu',
    fr: 'Shih Tzu'
  },
  'Boston Terrier': {
    en: 'Boston Terrier',
    'zh-CN': '波士顿梗',
    es: 'Boston Terrier',
    fr: 'Boston Terrier'
  },
  'Border Collie': {
    en: 'Border Collie',
    'zh-CN': '边境牧羊犬',
    es: 'Border Collie',
    fr: 'Border Collie'
  },
  'Australian Shepherd': {
    en: 'Australian Shepherd',
    'zh-CN': '澳大利亚牧牛犬',
    es: 'Pastor Australiano',
    fr: 'Berger Australien'
  },
  'Cockapoo': {
    en: 'Cockapoo',
    'zh-CN': '可卡布',
    es: 'Cockapoo',
    fr: 'Cockapoo'
  },
  'Cocker Spaniel': {
    en: 'Cocker Spaniel',
    'zh-CN': '可卡犬',
    es: 'Cocker Spaniel',
    fr: 'Cocker Spaniel'
  },
  'Mixed Breed': {
    en: 'Mixed Breed',
    'zh-CN': '混血犬',
    es: 'Raza Mixta',
    fr: 'Race Mixte'
  },

  // Cat breeds
  'Domestic Shorthair': {
    en: 'Domestic Shorthair',
    'zh-CN': '家猫短毛',
    es: 'Pelo Corto Doméstico',
    fr: 'Chat Domestique à Poil Court'
  },
  'Domestic Longhair': {
    en: 'Domestic Longhair',
    'zh-CN': '家猫长毛',
    es: 'Pelo Largo Doméstico',
    fr: 'Chat Domestique à Poil Long'
  },
  'Persian': {
    en: 'Persian',
    'zh-CN': '波斯猫',
    es: 'Persa',
    fr: 'Persan'
  },
  'Maine Coon': {
    en: 'Maine Coon',
    'zh-CN': '缅因猫',
    es: 'Maine Coon',
    fr: 'Maine Coon'
  },
  'British Shorthair': {
    en: 'British Shorthair',
    'zh-CN': '英国短毛猫',
    es: 'Pelo Corto Británico',
    fr: 'British Shorthair'
  },
  'Ragdoll': {
    en: 'Ragdoll',
    'zh-CN': '布偶猫',
    es: 'Ragdoll',
    fr: 'Ragdoll'
  },
  'Siamese': {
    en: 'Siamese',
    'zh-CN': '暹罗猫',
    es: 'Siamés',
    fr: 'Siamois'
  },
  'American Shorthair': {
    en: 'American Shorthair',
    'zh-CN': '美国短毛猫',
    es: 'Pelo Corto Americano',
    fr: 'American Shorthair'
  },
  'Scottish Fold': {
    en: 'Scottish Fold',
    'zh-CN': '苏格兰折耳猫',
    es: 'Scottish Fold',
    fr: 'Scottish Fold'
  },
  'Sphynx': {
    en: 'Sphynx',
    'zh-CN': '斯芬克斯猫',
    es: 'Sphynx',
    fr: 'Sphynx'
  },
  'Russian Blue': {
    en: 'Russian Blue',
    'zh-CN': '俄罗斯蓝猫',
    es: 'Azul Ruso',
    fr: 'Bleu Russe'
  },
  'Bengal': {
    en: 'Bengal',
    'zh-CN': '孟加拉猫',
    es: 'Bengal',
    fr: 'Bengal'
  },
  'Abyssinian': {
    en: 'Abyssinian',
    'zh-CN': '阿比西尼亚猫',
    es: 'Abisinio',
    fr: 'Abyssin'
  }
};

/**
 * Get localized breed name
 * @param breed - English breed name
 * @param language - Target language
 * @returns Localized breed name or original if not found
 */
export const getLocalizedBreedName = (breed: string, language: 'en' | 'zh-CN' | 'es' | 'fr'): string => {
  const breedData = BREED_NAMES[breed];
  if (!breedData) {
    return breed; // Return original if not found
  }
  return breedData[language] || breed;
};

/**
 * Get localized breed names for fallback arrays
 * @param petType - Type of pet ('dog' or 'cat')
 * @param language - Target language
 * @returns Array of localized breed names
 */
export const getLocalizedBreedArray = (petType: 'dog' | 'cat' | 'other', language: 'en' | 'zh-CN' | 'es' | 'fr'): string[] => {
  const dogBreeds = [
    'Golden Retriever', 'Labrador Retriever', 'German Shepherd', 'French Bulldog',
    'Bulldog', 'Poodle', 'Beagle', 'Rottweiler', 'German Shorthaired Pointer',
    'Yorkshire Terrier', 'Siberian Husky', 'Dachshund', 'Boxer', 'Great Dane',
    'Chihuahua', 'Shih Tzu', 'Boston Terrier', 'Border Collie', 'Australian Shepherd',
    'Cockapoo', 'Cocker Spaniel', 'Mixed Breed'
  ];
  
  const catBreeds = [
    'Domestic Shorthair', 'Domestic Longhair', 'Persian', 'Maine Coon',
    'British Shorthair', 'Ragdoll', 'Siamese', 'American Shorthair',
    'Scottish Fold', 'Sphynx', 'Russian Blue', 'Bengal', 'Abyssinian',
    'Mixed Breed'
  ];

  const breeds = petType === 'dog' ? dogBreeds : (petType === 'cat' ? catBreeds : ['Other']);
  return breeds.map(breed => getLocalizedBreedName(breed, language));
};

/**
 * Get localized fallback description
 * @param petType - Type of pet ('dog' or 'cat')
 * @param language - Target language
 * @returns Localized fallback description
 */
export const getLocalizedFallbackDescription = (petType: 'dog' | 'cat' | 'other', language: 'en' | 'zh-CN' | 'es' | 'fr'): string => {
  const descriptions = {
    en: {
      dog: "This beautiful dog looks amazing! While we couldn't analyze the image automatically, you can provide details manually in the next step.",
      cat: "This beautiful cat looks amazing! While we couldn't analyze the image automatically, you can provide details manually in the next step.",
      other: "This pet looks amazing! While we couldn't analyze the image automatically, you can provide details manually in the next step."
    },
    'zh-CN': {
      dog: "这只美丽的狗狗看起来很棒！虽然我们无法自动分析图像，但您可以在下一步中手动提供详细信息。",
      cat: "这只美丽的猫咪看起来很棒！虽然我们无法自动分析图像，但您可以在下一步中手动提供详细信息。",
      other: "您的宠物看起来很棒！虽然我们无法自动分析图像，但您可以在下一步中手动提供详细信息。"
    },
    es: {
      dog: "¡Este hermoso perro se ve increíble! Aunque no pudimos analizar la imagen automáticamente, puedes proporcionar detalles manualmente en el siguiente paso.",
      cat: "¡Este hermoso gato se ve increíble! Aunque no pudimos analizar la imagen automáticamente, puedes proporcionar detalles manualmente en el siguiente paso.",
      other: "¡Esta mascota se ve increíble! Aunque no pudimos analizar la imagen automáticamente, puedes proporcionar detalles manualmente en el siguiente paso."
    },
    fr: {
      dog: "Ce magnifique chien a l'air incroyable ! Bien que nous n'ayons pas pu analyser l'image automatiquement, vous pouvez fournir des détails manuellement à l'étape suivante.",
      cat: "Ce magnifique chat a l'air incroyable ! Bien que nous n'ayons pas pu analyser l'image automatiquement, vous pouvez fournir des détails manuellement à l'étape suivante.",
      other: "Cet animal a l'air incroyable !"
    }
  };

  const type = petType === 'other' ? 'other' : petType;
  return descriptions[language]?.[type as keyof typeof descriptions.en] || descriptions.en[type as keyof typeof descriptions.en];
};

/**
 * Get localized error message for AI analysis failure
 * @param language - Target language
 * @returns Localized error message
 */
export const getLocalizedAnalysisErrorMessage = (language: 'en' | 'zh-CN' | 'es' | 'fr'): string => {
  const messages = {
    en: "Unable to analyze this image clearly. Please provide additional details manually.",
    'zh-CN': "无法清楚地分析此图像。请手动提供其他详细信息。",
    es: "No se puede analizar esta imagen claramente. Por favor proporciona detalles adicionales manualmente.",
    fr: "Impossible d'analyser cette image clairement. Veuillez fournir des détails supplémentaires manuellement."
  };

  return messages[language] || messages.en;
};
